'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MenuItemRadio", {
    enumerable: true,
    get: function() {
        return MenuItemRadio;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useMenuItemRadio = require("./useMenuItemRadio");
const _renderMenuItemRadio = require("./renderMenuItemRadio");
const _useMenuItemRadioStylesstyles = require("./useMenuItemRadioStyles.styles");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const MenuItemRadio = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMenuItemRadio.useMenuItemRadio_unstable)(props, ref);
    (0, _useMenuItemRadioStylesstyles.useMenuItemRadioStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMenuItemRadioStyles_unstable')(state);
    return (0, _renderMenuItemRadio.renderMenuItemRadio_unstable)(state);
});
MenuItemRadio.displayName = 'MenuItemRadio';
